import { render, staticRenderFns } from "./IndexMeuComponent.vue?vue&type=template&id=0a5ade4b"
import script from "./IndexMeuComponent.vue?vue&type=script&lang=js"
export * from "./IndexMeuComponent.vue?vue&type=script&lang=js"
import style0 from "./IndexMeuComponent.vue?vue&type=style&index=0&id=0a5ade4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports